// This is intended to replace ContentBox and Heading component
import React from 'react';
import { Typography } from '@mui/material';

type Props = {
  title: string | React.ReactNode,
}

const HeadingTitle: React.FC<Props> = ({
  title,
}: Props) => (
  <Typography
    variant="h5"
    sx={{
      ml: '1em',
      mt: '1em',
    }}
  >
    {title}
  </Typography>
);

export default HeadingTitle;
